module.exports = __webpack_public_path__ + "static/media/apple-crate.a5561b09.svg";